export default function productsSearched({
  properties
}) {
  return {
    name: "Search",
    properties: {
      search_string: properties.query
    }
  };
}